import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Form, FormGroup, ValidationMessage } from '~/components/Form';
import { ServicesContext } from '~/services';

interface SaveNewFilterProps {
    onDismiss: () => void;
    formVals: TODO_TYPEME;
    clinic: TODO_TYPEME;
    PCP: TODO_TYPEME;
}
export function SaveNewFilter({ onDismiss, formVals, clinic, PCP }: SaveNewFilterProps) {
    const servicesContext = React.useContext(ServicesContext);
    const [adding, setAdding] = React.useState(false);
    const [filterName, setFilterName] = React.useState('');
    const [duplicateName, setDuplicateName] = React.useState(false);

    async function save() {
        try {
            setAdding(true);
            await servicesContext.user.addSavedSearchData(
                'saved_filters',
                {
                    ...formVals,
                    clinic,
                    PCP,
                    label: filterName,
                },
                { handledErrors: true }
            );
            setAdding(false);
            onDismiss();
        } catch (e) {
            setDuplicateName(true);
            setAdding(false);
        }
    }

    return (
        <div className="row text-center">
            <Form id="save-new-filter" className="col" onSubmit={save} values={{ filterName }}>
                <FormGroup htmlFor="filterName" submitted={false} validation={null}>
                    <input
                        placeholder="Enter Filter Name"
                        aria-label="Filter name input"
                        type="text"
                        className="form-control d-inline"
                        id="filterName"
                        required
                        maxLength={50}
                        value={filterName}
                        onChange={(e) => setFilterName(e.target.value)}
                    />
                    <button
                        className="ms-2 me-2 btn btn-secondary"
                        type="button"
                        onClick={onDismiss}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        form="save-new-filter"
                        className="btn btn-primary"
                        disabled={adding || !filterName}
                    >
                        {adding && (
                            <Spinner
                                animation="border"
                                variant="light"
                                size="sm"
                                role="status"
                                className="me-1"
                            />
                        )}
                        Save
                    </button>
                    <ValidationMessage
                        showBeforeSubmit
                        type="external"
                        rule={duplicateName}
                        className="col-12"
                    >
                        This filter name is already in use. Please select a unique name.
                    </ValidationMessage>
                </FormGroup>
            </Form>
        </div>
    );
}
